








import Vue from 'vue';
import { GapWarningInfo, IGapWarningConfig } from '@/api/gapwarning';
import {
  Component, Prop,
} from 'vue-property-decorator';

@Component
export default class GapWarning extends Vue {
    @Prop()
    warning!:IGapWarningConfig;
}
